<template>
  <div class="augmented-modal-data">
    <div class="block" :style="{ background: initialdata.bgColor }">
      <div
        v-if="initialdata.heading"
        class="heading"
        :style="{ color: initialdata.headingColor }"
        v-html="initialdata.heading"
      ></div>
      <div v-if="initialdata.subheading" class="title" v-html="initialdata.subheading"></div>
      <div v-if="initialdata.ctalink != null" style="text-align: center">
        <a class="ripple-animation augmented-block-button" :href="initialdata.ctalink">{{
          initialdata.ctalinkText
        }}</a>
      </div>
      <img
        v-if="initialdata.imageSrc != null"
        :src="initialdata.imageSrc"
        :alt="initialdata.imageAlt"
      />
      <img
        v-if="initialdata.image2Src != null"
        :src="initialdata.image2Src"
        :alt="initialdata.image2Alt"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'augmented-modal-data',
  props: {
    initialdata: {
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>
